import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import AdminReportDataService from "../../../services/admin-report.service";
import { Button, Table, Tooltip } from "antd";

const JewelryLogReports = () => {
  const { t } = useTranslation();
  const [downloadDataloading, setDownloadDataloading] = useState(false);
  const [JewelryLogReportsGridDataList, setJewelryLogReportsGridDataList] =
    useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(1000);
  const [sortColumnName, setSortColumnName] = useState("DID");
  const [sortType, setSortType] = useState("asc");

  useEffect(() => {
    handleGetJewelryLogReports(pageNo, pageSize, sortColumnName, sortType);
  }, []);

  /*Sorting API Starts*/
  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";
    //sorting
    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "ASC";
      column = "DID";
      setSortColumnName(column);
      setSortType(type);
    }
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    handleGetJewelryLogReports(
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };
  /*Sorting API Ends*/

  /*API Binding Starts*/
  const handleGetJewelryLogReports = (
    pageNo,
    pageSize,
    sortColumnName,
    sortOrder
  ) => {
    let inputData = {
      pageIndex: pageNo,
      pageSize: pageSize,
      sortColumnName: sortColumnName || "DID",
      sortOrder: sortOrder || "ASC",
    };
    setTableLoading(true);
    AdminReportDataService.GetJewelryLogReports(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var getJewelryLogReportsrespdatalis =
          responseData.getJewelryLogReportsrespdatalis;
        if (message === "Success") {
          if (responseData) {
            var temptotalRecords = responseData.totalRecord;
            setTotalCount(temptotalRecords);
            setJewelryLogReportsGridDataList(getJewelryLogReportsrespdatalis);
          }
        } else {
          setJewelryLogReportsGridDataList([]);
          setTotalCount(0);
        }
      })
      .catch((error) => {
        setTableLoading(false);
        setJewelryLogReportsGridDataList([]);
        console.log(error);
      })
      .finally(() => setTableLoading(false));
  };

  const handleJwellarylogDownload = () => {
    setDownloadDataloading(true);
    AdminReportDataService.jwellarylogDownload()
      .then((response) => {
        openInNewTab(response.data.responseData);
      })
      .catch((error) => {
        setDownloadDataloading(false);
        console.log(error);
      })
      .finally(() => setDownloadDataloading(false));
  };

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  /*API Binding Ends*/
  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields magento__mapping">
        <div className="row">
          <div className="col-md-12">
            <div className="heading__block">
              <h4 class="workarea__heading mt-0 mb-0">
                {t("Jewelry Log Reports")}
              </h4>

            </div>
          </div>

          <div className="limit_section">
            <div className="col-lg-12 mt-3">
              <div className="options__div">
                <div className="row">
                  <div  className="col-lg-12 crud__div" style={{ padding: "0px 5px 0px 5px" }}>
                    <Button
                      className="primary-btn"
                      onClick={() => handleJwellarylogDownload()}
                      loading={downloadDataloading}
                    >
                      {" "}
                      <i className="fa fa-download"></i> {t("Download")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div className="col-lg-12 col-md-12">
            <Table
              className="pendjewelreq__tbl"
              loading={tableLoading}
              columns={[
                {
                  title: (
                    <Tooltip title={t("Dealer ID")}>{t("Dealer ID")}</Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "did",
                  sorter: (a, b) => {},
                  showSorterTooltip: false,
                },
                {
                  title: (
                    <Tooltip title={t("Dealer Company")}>
                      {t("Dealer Company")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "dCompany",
                  sorter: (a, b) => {},
                  showSorterTooltip: false,
                },
                {
                  title: <Tooltip title={t("Count")}>{t("Count")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "count",
                  sorter: (a, b) => {},
                  showSorterTooltip: false,
                },
                {
                  title: (
                    <Tooltip title={t("Last Upload Date")}>
                      {t("Last Upload Date")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "modifiedDate",
                  showSorterTooltip: false,
                  sorter: (a, b) => {},
                  render: (index, record) =>
                    record.modifiedDate &&
                    record.modifiedDate.replace(
                      /(<([^>]+)>|12:00:00 AM|&nbsp;)/gi,
                      ""
                    ),
                },
              ]}
              dataSource={JewelryLogReportsGridDataList}
              scroll={{ y: "calc(100vh - 340px)" }}
              pagination={{
                size: "small",
                total: totalCount,
                pageNo: pageNo,
                pageSize: pageSize,
                pageSizeOptions: [10, 15, 20, 50, 100],
                responsive: true,
                showSizeChanger: true,
              }}
              onChange={handleTableASCDES}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default JewelryLogReports;
